if (!customElements.get('sticky-atb-bar')) {
  customElements.define(
    'sticky-atb-bar',
    class StickyAtbBar extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.variantChangeUnsubscriber = null;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = document.getElementById(`StickySubmitButton-${this.sectionId}`);
        this.stickyPrice = document.getElementById(`StickyPrice-${this.sectionId}`);
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);

        if (!this.mainButton || !this.stickyButton) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('sticky-atb--visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);

        this.syncFromMainButton();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.sectionId) return;
          this.syncFromMainButton();
          this.syncPrice();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      syncFromMainButton() {
        if (!this.mainButton || !this.stickyButton) return;

        const mainText = this.mainButton.querySelector('span:not(.loading__spinner):not(.sold-out-message):not(.icon-wrap)');
        const stickyText = this.stickyButton.querySelector('span:not(.loading__spinner)');

        if (mainText && stickyText) {
          stickyText.textContent = mainText.textContent;
        }

        if (this.mainButton.hasAttribute('disabled')) {
          this.stickyButton.setAttribute('disabled', 'disabled');
        } else {
          this.stickyButton.removeAttribute('disabled');
        }

        this.stickyButton.classList.remove('loading');
        this.stickyButton.removeAttribute('aria-disabled');
        this.stickyButton.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      syncPrice() {
        if (!this.mainPrice || !this.stickyPrice) return;
        this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
      }
    }
  );
}
